enum ActionsTypes {
    SET_SUBSCRIPTION_DATA = 'SET_SUBSCRIPTION_DATA',
}

export type ActionType = keyof typeof ActionsTypes;

export default ActionsTypes;
